"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchComponentData;
/**
 * fetchComponentData collects all load actions in the components and
 * returns a Promise that resolves when all the loads have been resolved. This is to
 * ensure that all APIs are resolved before rendering the page.
 *
 * fetchComponentData will also collect the load actions from inner-components
 */

function fetchComponentData(dispatch, components, param) {
  const loads = components.reduce((preLoads, component) => {
    return (component && component.load ? component.load : []
    // Add the WrappedComponent's load if it exists
    ).concat(component && component.WrappedComponent && component.WrappedComponent.load ? component.WrappedComponent.load : []).concat(preLoads);
  }, []);
  const promises = loads.map(load => dispatch(load(param, dispatch)));
  return Promise.all(promises);
}